import { render, staticRenderFns } from "./WorkflowOpsMenu.vue?vue&type=template&id=27eb1524"
import script from "./WorkflowOpsMenu.vue?vue&type=script&lang=js"
export * from "./WorkflowOpsMenu.vue?vue&type=script&lang=js"
import style0 from "./mqSharedStyles.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27eb1524')) {
      api.createRecord('27eb1524', component.options)
    } else {
      api.reload('27eb1524', component.options)
    }
    module.hot.accept("./WorkflowOpsMenu.vue?vue&type=template&id=27eb1524", function () {
      api.rerender('27eb1524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowOpsMenu.vue"
export default component.exports